// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../log-in-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay h2[data-v-38d2c1fa]{margin-top:2rem;color:#dcdcdc}", ""]);
// Exports
module.exports = exports;
